export const computeHorizontalBarWidth = (basicValue: number, value: number): number => (100 * value) / basicValue;
